import React, { useState } from 'react';
import { SearchIcon, ChevronLeftIcon, ActivityIcon, ScissorsIcon, HeartPulseIcon, BabyIcon, StethoscopeIcon, SyringeIcon, BoneIcon } from 'lucide-react';
interface AreaSelectionProps {
  onBack: () => void;
  onSelectArea: (areaName: string) => void;
}
const AREAS = [{
  id: '1',
  name: 'Emergencia',
  icon: ActivityIcon,
  lastCollection: 'Hace 2 horas'
}, {
  id: '2',
  name: 'Quirófano',
  icon: ScissorsIcon,
  lastCollection: 'Hace 45 min'
}, {
  id: '3',
  name: 'UCI',
  icon: HeartPulseIcon,
  lastCollection: 'Hace 3 horas'
}, {
  id: '4',
  name: 'Pediatría',
  icon: BabyIcon,
  lastCollection: 'Ayer'
}, {
  id: '5',
  name: 'Maternidad',
  icon: BabyIcon,
  lastCollection: 'Hace 5 horas'
}, {
  id: '6',
  name: 'Medicina Interna',
  icon: StethoscopeIcon,
  lastCollection: 'Hace 1 hora'
}, {
  id: '7',
  name: 'Cirugía',
  icon: SyringeIcon,
  lastCollection: 'Hace 4 horas'
}, {
  id: '8',
  name: 'Ortopedia',
  icon: BoneIcon,
  lastCollection: 'Ayer'
}];
export function AreaSelection({
  onBack,
  onSelectArea
}: AreaSelectionProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const filteredAreas = AREAS.filter(area => area.name.toLowerCase().includes(searchQuery.toLowerCase()));
  return <div className="flex flex-col h-full w-full bg-gray-50" data-id="element-31">
      {/* Header */}
      <header className="flex items-center px-4 py-4 text-white shadow-md z-10 shrink-0" style={{
      backgroundColor: '#134073'
    }} data-id="element-32">
        <button onClick={onBack} className="p-1 -ml-1 mr-2 active:bg-white/20 rounded-full transition-colors" data-id="element-33">
          <ChevronLeftIcon className="w-7 h-7" data-id="element-34" />
        </button>
        <h1 className="font-bold text-xl" data-id="element-35">Seleccionar Área</h1>
      </header>

      {/* Search Bar */}
      <div className="p-4 bg-white border-b border-gray-200 shrink-0" data-id="element-36">
        <div className="relative" data-id="element-37">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-38">
            <SearchIcon className="h-5 w-5 text-gray-400" data-id="element-39" />
          </div>
          <input type="text" placeholder="Buscar área o servicio..." className="block w-full pl-10 pr-4 py-3 h-12 bg-gray-100 border-transparent rounded-xl text-gray-900 placeholder-gray-500 focus:bg-white focus:ring-2 focus:border-transparent text-base" style={{
          focusRingColor: '#3d99d2'
        }} value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-40" />
        </div>
      </div>

      {/* Area List */}
      <div className="flex-1 overflow-y-auto p-4" data-id="element-41">
        <div className="flex flex-col gap-3 pb-safe" data-id="element-42">
          {filteredAreas.map(area => {
          const Icon = area.icon;
          return <button key={area.id} onClick={() => onSelectArea(area.name)} className="flex items-center p-4 bg-white rounded-xl shadow-sm border border-gray-100 active:bg-gray-50 transition-colors text-left" data-id="element-43">
                <div className="w-12 h-12 rounded-full flex items-center justify-center mr-4 shrink-0" style={{
              backgroundColor: '#e6f2f9',
              color: '#134073'
            }} data-id="element-44">
                  <Icon className="w-6 h-6" data-id="element-45" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-46">
                  <h3 className="text-lg font-bold text-gray-900 truncate" data-id="element-47">
                    {area.name}
                  </h3>
                  <p className="text-sm text-gray-500 truncate" data-id="element-48">
                    Última recolección: {area.lastCollection}
                  </p>
                </div>
              </button>;
        })}

          {filteredAreas.length === 0 && <div className="text-center py-10 text-gray-500" data-id="element-49">
              <p data-id="element-50">No se encontraron áreas con ese nombre.</p>
            </div>}
        </div>
      </div>
    </div>;
}